// Environment configuration
// This file provides type-safe access to environment variables

export interface EnvironmentConfig {
  apiBaseUrl: string;
  apiTimeout: number;
  analyticsId: string;
  sentryDsn: string;
  enableDebug: boolean;
  enableMockData: boolean;
  environment: string;
  buildTime: string;
  // AWS Cognito Configuration
  userPoolId: string;
  userPoolClientId: string;
}

// Get environment variables with fallbacks
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  
  return {
    apiBaseUrl: apiBaseUrl || '', // Empty string for production, API URL for development
    apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '5000'),
    analyticsId: import.meta.env.VITE_ANALYTICS_ID || '',
    sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    enableMockData: import.meta.env.VITE_ENABLE_MOCK_DATA === 'true',
    environment: import.meta.env.VITE_ENVIRONMENT || 'development',
    buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
    // AWS Cognito Configuration
    userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || ''
  };
};

// Export the current environment configuration
export const env = getEnvironmentConfig();

// Helper functions
export const isDevelopment = () => env.environment === 'development';
export const isProduction = () => env.environment === 'production';
export const isDebugEnabled = () => env.enableDebug;
export const isMockDataEnabled = () => env.enableMockData;
